import { Component, OnInit } from '@angular/core';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { UserAudit } from '../shared/models/user.model';
import { DownloadFileService } from '../services/download-file.service';

@Component({
  selector: 'app-compliance-regulations',
  templateUrl: './compliance-regulations.component.html',
  styleUrls: ['./compliance-regulations.component.scss']
})
export class ComplianceRegulationsComponent implements OnInit {

  secName = 'ComplianceAndRegulations'
  complianceandRegulationPageConents;
  userAudit: UserAudit;
  isLoadingData: boolean;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private adminRepository: AdminRepositoryService,
    private userRepositoryService: UserRepositoryService,
    private downloadFileService: DownloadFileService,
  private adminRepositoryService: AdminRepositoryService) { }

  ngOnInit(): void {
    this.complianceContent(); 
  }
  complianceContent() {
    this.isLoadingData = true;
    this.adminRepository.getStaticContentForCompliance(this.secName)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((complianceandRegulationContents) => {
        if (complianceandRegulationContents) {
          this.complianceandRegulationPageConents = complianceandRegulationContents[0].sectionDetailJson.sectionDescription;
          document.getElementById("complianceRegulationContent").innerHTML = this.complianceandRegulationPageConents;

          const lis = document.getElementById('complianceRegulationContent').getElementsByTagName('a');

          for (let indx = 0; indx < lis.length; indx++) {

            const fullhref = lis[indx].getAttribute('href');
            if (!fullhref.startsWith('https')) {
              lis[indx].addEventListener('click', (event) => {
                event.preventDefault();
                this.listClicked(event.currentTarget);
              });
            }
          }
          this.isLoadingData = false;
        }
      });
  }

  listClicked(event) { 
    var complianceCat = 'Compliance and Regulations';
    var documentName = event.href.substring(event.href.lastIndexOf('/')+1);
    var userAuditPayLoad = {
      documentName: documentName, // event.innerText,
      documentCategory: complianceCat,
      action: 'View',
      extension: "." + documentName.split('.').pop() || '',
      formName: documentName.split(".")[0]
    };
    
 this.adminRepositoryService
        .getComplianceFile(documentName)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (solarFormDownloadData: any) => {
            this.downloadFileService.previewSolarForm(solarFormDownloadData, userAuditPayLoad);//previewSolarForm(solarFormDownloadData, logHeader);
          },
          (err) => {
            // this.snackBService.showError(err);
          }
        );


    this.userRepositoryService.getLogData(userAuditPayLoad)
            .pipe(
              takeUntil(this.unsubscribe))
            .subscribe(
              (response) => {}
            );         
  }
}
